export default "__VITE_ASSET__c625fb90__"